import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { LoomOverlayTemplate } from "@/components/signup/layouts";
import SiteActivation from "@/components/signup/site-activation";

import { CreateASiteHeading } from "../../components";

export const LoggedInLoomNewUser = () => (
    <LoomOverlayTemplate size="sm">
        <Content />
    </LoomOverlayTemplate>
);

const Content = () => {
    const { formatMessage } = useIntl();
    const intl = useIntl();

    const subHeaderText = intl.formatMessage({
        id: "siteActivation.loggedInLoom.newUser",
        defaultMessage:
            "Sites are shared spaces to organize work, teams, and projects."
    });

    return (
        <>
            <h1 css={headerCss}>
                <span css={accentImageSpanCss}>
                    <CreateASiteHeading />
                </span>
            </h1>
            <p css={subheadingCss}>{subHeaderText}</p>
            <SiteActivation />
            <footer css={footerCss}>
                {formatMessage({
                    id: "JiraSoftwarePageTemplate.loggedInHero.recatcha",
                    defaultMessage:
                        "This page is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply."
                })}
            </footer>
        </>
    );
};

const headerCss = css({
    margin: 0,
    textAlign: "center"
});

const accentImageSpanCss = css({
    position: "relative"
});

const footerCss = css({
    fontSize: 12,
    fontWeight: 400,
    margin: 0,
    fontFamily: "Charlie Text"
});

const subheadingCss = css({
    fontSize: 16,
    fontWeight: 400,
    textAlign: "center",
    lineHeight: "24px",
    fontFamily: "Charlie Text",
    margin: "16px 0 0"
});
